import Modal from './components/modal'

$(document).ready(function () {
  if($('.protectedanimals').length > 0) {
    const carouselAnimal = document.querySelector('.carousel-animals');
    if (carouselAnimal) {
      new Glider(carouselAnimal, {
        slidesToShow: 1.5,
        slidesToScroll: 1,
        draggable: true,
        dots: '#dots-animal',
        arrows: {
          prev: '#glider-prev-animal',
          next: '#glider-next-animal'
        },
        responsive: [
          {
            breakpoint: 900,
            settings: {
              slidesToShow: 4.3,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 575,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }
        ]
      })
    }
    if(($(this).find('#dots-animal').children().length < 2 )) {
      $(this).find("#dots-animal").hide();
      $(this).find(".glider-prev").hide();
      $(this).find(".glider-next").hide();
    }
  }
  if($('.modal-uicn').length > 0) {
    const modal = new Modal('#modal-uicn')
    $( ".btn-open-modal-uicn" ).each(function(index) {
      $(this).on("click", function(e){
        e.preventDefault()
        e.stopPropagation()
        modal.open()
      });
    });
  }
});
